
import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from './L7.module.scss';
import { BsPencil } from "react-icons/bs";
import classnames from 'classnames';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { API_BASE_URL, WELCOME_PAGE_URL } from '../utils/constants';


class L7 extends React.Component {
  

  render() {
    return (
      <Row className={classnames("exercise-box", styles.exerciseBox7, this.props.className)}>
          <Col className="text-center">
            <h4><BsPencil /> ZADANIE</h4>
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content1 }}></p>
            <AudioPlayer
              src={this.props.params.audiosrc1}
              onPlay={e=> {
                let data = {
                  accessKey: this.props.lessonKey,
                  description: "L7_audio1_play"
                };
                fetch(API_BASE_URL + "/task/event", {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
              }}
            />
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content2 }}></p>
            
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content3 }}></p>
            <hr/>
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content4 }}></p>
            <AudioPlayer
              src={this.props.params.audiosrc4}
              onPlay={e=> {
                let data = {
                  accessKey: this.props.lessonKey,
                  description: "L7_audio2_play"
                };
                fetch(API_BASE_URL + "/task/event", {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
              }}
            />
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content5 }}></p>
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content6 }}></p>
            <AudioPlayer
              src={this.props.params.audiosrc6}
              onPlay={e=> {
                let data = {
                  accessKey: this.props.lessonKey,
                  description: "L7_audio3_play"
                };
                fetch(API_BASE_URL + "/task/event", {
                    method: 'post',
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
              }}
            />
            <p className={classnames("text-justify", styles.mspacing)} dangerouslySetInnerHTML={ { __html: this.props.params.content7 }}></p>
          </Col>
      </Row>
    );
  }
}

export default L7;